import { Component, OnInit } from '@angular/core';
import { DepartmentBase } from '../department.base';

@Component({
  selector: 'dpto-08',
  templateUrl: './dpto08.component.html',
  styleUrls: ['../department/department.component.css']
})
export class Dpto08Component extends DepartmentBase {
  municipalities = [{
    "id": 126,
    "code": "08001",
    "name": "Barranquilla",
    "state": "1",
    "department_code": "8"
  }, {
    "id": 127,
    "code": "08078",
    "name": "Baranoa",
    "state": "1",
    "department_code": "8"
  }, {
    "id": 128,
    "code": "08137",
    "name": "Campo de La Cruz",
    "state": "1",
    "department_code": "8"
  }, {
    "id": 129,
    "code": "08141",
    "name": "Candelaria",
    "state": "1",
    "department_code": "8"
  }, {
    "id": 130,
    "code": "08296",
    "name": "Galapa",
    "state": "1",
    "department_code": "8"
  }, {
    "id": 131,
    "code": "08372",
    "name": "Juan de Acosta",
    "state": "1",
    "department_code": "8"
  }, {
    "id": 132,
    "code": "08421",
    "name": "Luruaco",
    "state": "1",
    "department_code": "8"
  }, {
    "id": 133,
    "code": "08433",
    "name": "Malambo",
    "state": "1",
    "department_code": "8"
  }, {
    "id": 134,
    "code": "08436",
    "name": "Manat\u00ed",
    "state": "1",
    "department_code": "8"
  }, {
    "id": 135,
    "code": "08520",
    "name": "Palmar de Varela",
    "state": "1",
    "department_code": "8"
  }, {
    "id": 136,
    "code": "08549",
    "name": "Pioj\u00f3",
    "state": "1",
    "department_code": "8"
  }, {
    "id": 137,
    "code": "08558",
    "name": "Polonuevo",
    "state": "1",
    "department_code": "8"
  }, {
    "id": 138,
    "code": "08560",
    "name": "Ponedera",
    "state": "1",
    "department_code": "8"
  }, {
    "id": 139,
    "code": "08573",
    "name": "Puerto Colombia",
    "state": "1",
    "department_code": "8"
  }, {
    "id": 140,
    "code": "08606",
    "name": "Repel\u00f3n",
    "state": "1",
    "department_code": "8"
  }, {
    "id": 141,
    "code": "08634",
    "name": "Sabanagrande",
    "state": "1",
    "department_code": "8"
  }, {
    "id": 142,
    "code": "08638",
    "name": "Sabanalarga",
    "state": "1",
    "department_code": "8"
  }, {
    "id": 143,
    "code": "08675",
    "name": "Santa Luc\u00eda",
    "state": "1",
    "department_code": "8"
  }, {
    "id": 144,
    "code": "08685",
    "name": "Santo Tom\u00e1s",
    "state": "1",
    "department_code": "8"
  }, {
    "id": 145,
    "code": "08758",
    "name": "Soledad",
    "state": "1",
    "department_code": "8"
  }, {
    "id": 146,
    "code": "08770",
    "name": "Suan",
    "state": "1",
    "department_code": "8"
  }, {
    "id": 147,
    "code": "08832",
    "name": "Tubar\u00e1",
    "state": "1",
    "department_code": "8"
  }, {
    "id": 148,
    "code": "08849",
    "name": "Usiacur\u00ed",
    "state": "1",
    "department_code": "8"
  }]
}
